import { debug } from "../../loader/utils/debug";
/**
 * Storage Utility Functions
 *
 * Helper functions for managing widget state in localStorage.
 */

const STORAGE_PREFIX = "apten-widget-";

/**
 * Safely get an item from localStorage
 */
export function getStorageItem<T>(key: string, defaultValue: T): T {
  try {
    const item = localStorage.getItem(STORAGE_PREFIX + key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    debug.warn(`[Apten Widget] Failed to get storage item "${key}":`, error);
    return defaultValue;
  }
}

/**
 * Safely set an item in localStorage
 */
export function setStorageItem<T>(key: string, value: T): void {
  try {
    localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
  } catch (error) {
    debug.warn(`[Apten Widget] Failed to set storage item "${key}":`, error);
  }
}

/**
 * Remove an item from localStorage
 */
export function removeStorageItem(key: string): void {
  try {
    localStorage.removeItem(STORAGE_PREFIX + key);
  } catch (error) {
    debug.warn(
      `[Apten Widget] Failed to remove storage item "${key}":`,
      error
    );
  }
}

/**
 * Check if localStorage is available
 */
export function isStorageAvailable(): boolean {
  try {
    const test = "__storage_test__";
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch {
    return false;
  }
}

/**
 * Clear all widget-related items from localStorage
 */
export function clearWidgetStorage(): void {
  try {
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (key.startsWith(STORAGE_PREFIX)) {
        localStorage.removeItem(key);
      }
    });
  } catch (error) {
    debug.warn("[Apten Widget] Failed to clear widget storage:", error);
  }
}
